import React from "react";

export const QuizListSkeleton: React.FC = () => {
  return (
    <div className="flex flex-col gap-3 animate-pulse">
      {Array.from({ length: 3 }).map((_, i) => (
        <div
          key={i}
          className="h-20 rounded-2xl bg-muted/40 dark:bg-neutral-800/50"
        />
      ))}
    </div>
  );
};
